import React from "react";

export function TablePaginationArrowRight(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#CBD5E1" />
      <path
        d="M24.3857 20.6355L24.3856 20.6356L18.1356 26.8856C17.9668 27.0544 17.7379 27.1492 17.4992 27.1492C17.2605 27.1492 17.0315 27.0544 16.8627 26.8856C16.6939 26.7168 16.5991 26.4879 16.5991 26.2492C16.5991 26.0105 16.6939 25.7815 16.8627 25.6127L22.4495 20.0276L22.4771 20L22.4495 19.9723L16.8643 14.3856L16.8643 14.3856C16.7807 14.302 16.7144 14.2028 16.6692 14.0936C16.624 13.9844 16.6007 13.8674 16.6007 13.7492C16.6007 13.631 16.624 13.5139 16.6692 13.4047C16.7144 13.2955 16.7807 13.1963 16.8643 13.1127C16.9479 13.0292 17.0471 12.9629 17.1563 12.9176C17.2655 12.8724 17.3825 12.8491 17.5007 12.8491C17.6189 12.8491 17.736 12.8724 17.8452 12.9176C17.9544 12.9629 18.0536 13.0292 18.1372 13.1127L24.3872 19.3627L24.3872 19.3628C24.4709 19.4463 24.5372 19.5456 24.5824 19.6548C24.6276 19.7641 24.6508 19.8812 24.6507 19.9995C24.6506 20.1177 24.6271 20.2348 24.5816 20.3439C24.5361 20.4531 24.4696 20.5522 24.3857 20.6355Z"
        fill="#1E293B"
        stroke="#1E293B"
        strokeWidth="0.078125"
      />
    </svg>
  );
}
